import { FC } from 'react';
import { Badge } from 'reactstrap';

interface CountBadgeProps {
  count: number | string | undefined;
};

const CountBadge: FC<CountBadgeProps> = (props: CountBadgeProps) => {
  const { count } = props;

  return (
    count && (typeof count !== 'object') && (count > 0 || count !== '0') ? (
      <Badge color="secondary">
        {count}
      </Badge>
    ) : null
  );
};

export default CountBadge;